import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ALLOWED_EMAILS } from '../components/Navbar';


export default function ProtectedRoute({ children }) {
const { user, loading } = useAuth();
const location = useLocation();


if (loading) return <div className="p-8">Loading…</div>;
if (!user || !ALLOWED_EMAILS.includes(user.email)) return <Navigate to="/" state={{ from: location }} replace />;


return children;
}